<template>
  <div>
    <b-overlay :show="loading">
      <div>
        <b-card>
          <h4>แคมเปญ : {{ cDisplayTitle }}</h4>
          <p><b>หมายเหตุ :</b> {{ cDisplayDetail }}</p>
          <p class="mb-50"><b>รูปหลักที่ร่วมแคมเปญนี้ :</b> {{ cDisplayNameMainImage }}</p>
          <p class="mb-50"><b>วันที่เปิดใช้งาน :</b> {{ cMainStartDate }}</p>
          <p class="mb-50"><b>วันหมดอายุ :</b> {{ cMainEndDate }}</p>
          <p class="mb-50"><b>จำกัดจำนวนการใช้ 1 Redeem Code / ครั้ง :</b> {{ cDisplayLimitUse }}</p>
          <p><b>รูปแบบการขาย :</b> {{ cDisplayHideInStore }}</p>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            @click="clickEditMainData"
            block
            size="sm"
          >
            แก้ไขรายละเอียดทั่วไป
          </b-button>

          <b-button
            v-if="mainData"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            :variant="mainData.is_active ? 'danger' : 'success'"
            @click="toggleActiveCode"
            block
            size="sm"
          >
            {{ cBtnToggleActiveCode }}
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="danger"
            block
            size="sm"
            @click="forceDeleteRedeem"
          >
            บังคับลบแคมเปญนี้ (ให้สอบถามผู้ดูแลก่อนลบแบบนี้)
          </b-button>
          <hr />

          <p class="mb-50">จำนวน Code ที่ต้องการเพิ่ม</p>
          <b-row cols="1" cols-sm="2" no-gutters>
            <b-col class="mb-50 mb-sm-0 mr-sm-50">
              <b-form-input v-model="addOnAmount" :formatter="formatterAmount" number />
            </b-col>
            <b-col sm="auto">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" @click="addMoreCode" block>
                เพิ่ม
              </b-button>
            </b-col>
          </b-row>
        </b-card>

        <table-local-v-1-widget
          :items="cRedeemCodeList"
          :columns="cColumns"
          :actions="actions"
          title="ประวัติการใช้ Redeem"
        >
          <template #cardHeader>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              block
              class="mb-1"
              size="sm"
              @click="copyAllCodeIsNotUse"
            >
              คัดลอก Code ที่ยังไม่ถูกใช้งานทั้งหมด
            </b-button>
          </template>
          <template #user_id="{row}">
            <div>
              <b-badge :variant="row.user_id ? 'success' : 'secondary'">
                {{ row.user_id ? 'ใช้งานแล้ว' : 'ยังไม่ถูกใช้งาน' }}
              </b-badge>
            </div>
          </template>

          <template #use_by="{row}">
            <div class="d-flex align-items-center justify-content-center">
              <div class="mr-50">
                <span v-if="mainData.limited_use">
                  {{ `${row.total_use} / 1` }}
                </span>
                <span v-else>
                  {{ `${row.total_use} / ไม่จำกัด` }}
                </span>
              </div>
            </div>
          </template>

          <template #customAction="{row}">
            <div>
              <b-button
                v-if="!row.user_id"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="flat-danger"
                class="btn-icon"
                size="sm"
                @click="clickDeleteCodeRedeem(row)"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>
              <b-button
                v-else
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-tooltip.hover.top="'ดูรายละเอียดผู้ใช้งาน'"
                variant="flat-primary"
                class="btn-icon"
                size="sm"
                :to="{
                  name: 'redeem-management-use-by-details',
                  params: { redeemCodeId: row.id, redeemCode: row.code },
                }"
              >
                <feather-icon icon="EyeIcon" />
              </b-button>
            </div>
          </template>
        </table-local-v-1-widget>
      </div>
    </b-overlay>

    <b-modal
      ref="refModalFormRedeem"
      title="แก้ไขรายะเอียดทั่วไป"
      size="xl"
      hide-backdrop
      hide-footer
      modal-class="modal-primary"
    >
      <form-create-redeem ref="refFormRedeemInModal" @onSubmit="onSubmitFormEdit" />
    </b-modal>

    <!-- <pre>{{ JSON.stringify(mainData, null, 2) }}</pre> -->
  </div>
</template>

<script>
import FormCreateRedeem from './components/FormCreateRedeem.vue'

export default {
  components: {
    FormCreateRedeem,
  },
  data() {
    return {
      loading: false,
      mainData: null,
      columns: [
        {
          label: 'Code',
          field: 'code',
          tdClass: 'text-center',
          thClass: 'text-center',
        },
        {
          label: 'สถานะ',
          field: 'user_id',
          tdClass: 'text-center',
          thClass: 'text-center',
          type: 'custom',
        },
        {
          label: 'ใช้ไป / ทั้งหมด',
          field: 'use_by',
          tdClass: 'text-center',
          thClass: 'text-center',
          type: 'custom',
          sortable: false,
        },

        {
          label: '',
          field: 'customAction',
          tdClass: 'text-center',
          thClass: 'text-center',
          type: 'custom',
          sortable: false,
        },
      ],
      actions: [],
      addOnAmount: 1,
    }
  },
  computed: {
    cColumns() {
      // if (this.mainData?.limited_use) {
      //   return [
      //     ...this.columns.slice(0, 2),
      //     {
      //       label: 'ใช้งานโดย',
      //       field: 'use_by',
      //       formatFn: val => val?.email || '-',
      //       tdClass: 'text-center',
      //       thClass: 'text-center',
      //     },
      //     this.columns[2],
      //   ]
      // }

      return [...this.columns]
    },
    cDisplayTitle() {
      return this.mainData?.name
    },
    cDisplayDetail() {
      return this.mainData?.detail
    },
    cRedeemCodeList() {
      return this.mainData?.redeeming_code_datas || []
    },
    cDisplayNameMainImage() {
      return this.mainData?.topic_image_data?.name
    },
    cMainStartDate() {
      if (this.mainData?.start_date) {
        return this.$date(this.mainData.start_date)
          .locale('th')
          .format('DD MMM YYYY HH:mm')
      }

      return ''
    },
    cMainEndDate() {
      if (this.mainData?.end_date) {
        return this.$date(this.mainData.end_date)
          .locale('th')
          .format('DD MMM YYYY HH:mm')
      }

      return 'ไม่มีวันหมดอายุ'
    },
    cBtnToggleActiveCode() {
      return this.mainData?.is_active ? 'ปิดการใช้งาน Redeem ทั้งหมด' : 'เปิดการใช้งาน Redeem ทั้งหมด'
    },
    cDisplayHideInStore() {
      if (!this.mainData?.topic_image_data) return ''

      return this.mainData?.topic_image_data.hide_in_store
        ? 'ไม่แสดงในแอปและเว็บ (สามารถใช้ Redeem เพื่อสร้างรูปวอลเปเปอร์ได้เท่านั้น)'
        : 'แสดงในแอปและเว็บ (สามารถใช้ Redeem หรือ Coin เพื่อสร้างรูปวอลเปเปอร์ได้)'
    },
    cDisplayLimitUse() {
      if (!this.mainData) return ''
      if ('limited_use' in this.mainData) {
        return this.mainData.limited_use ? 'ใช่' : 'ไม่'
      }

      return 'ไม่พบข้อมูล'
    },
  },
  mounted() {
    const { redeemMainId } = this.$route.params

    if (redeemMainId) {
      this.fetchMainDataRedeemById(redeemMainId)
    } else {
      this.gDisplayToast('ไม่พบแคมเปญ', 'ดูเหมือนแคมเปญนี้จะถูกลบไปแล้ว', 'danger')
      this.$router.replace({ name: 'redeem-management' })
    }
  },
  methods: {
    async fetchMainDataRedeemById(id = '') {
      if (!id) return
      this.loading = true
      const resp = await this.api.getV2(`api/admin/redeeming-topic-data/${id}`).catch(() => null)
      //   console.log('fetchMainDataRedeemById', resp)

      if (resp && resp.code === 200) {
        this.mainData = { ...resp.data }
      } else {
        this.gDisplayToast('ไม่พบแคมเปญ', 'ดูเหมือนแคมเปญนี้จะถูกลบไปแล้ว', 'danger')
        this.$router.replace({ name: 'redeem-management' })
      }
      this.loading = false
    },
    async clickDeleteCodeRedeem(values) {
      const resp = await this.api.deleteV2(`api/admin/redeeming-code-data/${values.id}`, this, true)

      if (!resp) return

      if (resp.message) {
        this.gDisplayToast('พบข้อผิดพลาด', resp.message, 'danger')
        return
      }
      this.gDisplayToast('ลบ Code สำเร็จแล้ว')

      this.fetchMainDataRedeemById(this.$route.params.redeemMainId)
    },
    async addMoreCode() {
      if (this.addOnAmount <= 0) {
        this.gDisplayToast('ไม่สามารถเพิ่ม Code ได้', 'จำนวน Code ที่ต้องการเพิ่มต้องมีค่ามากกว่า 1', 'danger')

        return
      }
      const checkConfirm = await this.gCheckConfirmV1(
        'ยืนยันเพิ่ม Code สำหรับแคมเปญนี้',
        `จำนวน Code ที่ต้องการเพิ่มคือ ${this.addOnAmount} Code`,
      )

      if (!checkConfirm) return

      const requestData = {
        ...this.mainData,
        amount: this.addOnAmount,
        hide_in_store: this.mainData.topic_image_data.hide_in_store,
      }
      this.loading = true
      const resp = await this.api.putV2(`api/admin/redeeming-topic-data/${this.mainData.id}`, requestData, this)
      this.loading = false
      if (!resp) return

      if (resp && resp.code === 200) {
        this.gDisplayToast('เพิ่ม Code สำเร็จแล้ว')
        this.fetchMainDataRedeemById(this.mainData.id)
      } else {
        this.gDisplayToast('เพิ่ม Code ไม่สำเร็จ', resp?.data?.message, 'danger')
      }
    },
    formatterAmount(value) {
      const n = Number(value)
      if (Number.isNaN(n)) return value
      return Math.round(n)
    },
    clickEditMainData() {
      this.$refs.refModalFormRedeem.show()

      setTimeout(() => {
        // eslint-disable-next-line no-unused-expressions
        this.$refs.refFormRedeemInModal?.updateForm({
          ...this.mainData,
          hide_in_store: this.mainData?.topic_image_data?.hide_in_store,
        })
      }, 250)
    },
    async onSubmitFormEdit(values) {
      const checkConfirm = await this.gCheckConfirmV1('ยืนยันแก้ไขรายละเอียดทั่วไป')
      if (!checkConfirm) return
      this.$refs.refModalFormRedeem.hide()

      this.loading = true
      const resp = await this.api.putV2(`api/admin/redeeming-topic-data/${values.id}`, values, this)
      this.loading = false
      if (!resp) return

      if (resp && resp.code === 200) {
        this.gDisplayToast('แก้ไขรายละเอียดทั่วไปสำเร็จ')
        this.fetchMainDataRedeemById(values.id)
      } else {
        this.gDisplayToast('แก้ไขรายละเอียดทั่วไปไม่สำเร็จ', resp?.data?.message, 'danger')
      }
    },
    async toggleActiveCode() {
      const title = this.mainData.is_active ? 'ยืนยันปิดการใช้งาน' : 'ยืนยันเปิดการใช้งาน'

      const checkConfirm = await this.gCheckConfirmV1(title)
      if (!checkConfirm) return
      this.loading = true
      const resp = await this.api
        .getV2(`api/admin/redeeming-topic-data/toggle-active/${this.mainData.id}`)
        .catch(() => null)
      this.loading = false
      if (resp && resp.code === 200) {
        this.gDisplayToast(`${title} สำเร็จแล้ว`)
        this.mainData.is_active = !this.mainData.is_active
      } else {
        this.gDisplayToast('พบข้อผิดพลาด', resp?.data?.message, 'danger')
      }
    },
    async forceDeleteRedeem() {
      const resp = await this.api.deleteV2(
        `api/admin/redeeming-topic-data/confirm-delete/${this.mainData.id}`,
        this,
        true,
        {
          title: 'ยืนยันบังคับลบแคมเปญนี้',
          body: 'ระบบจะทำการลบแคมเปญนี้ โดยที่ไม่สนใจ Code ที่มีการถูกใช้ไปแล้ว โปรดตรวจสอบให้แน่ใจก่อนกดยืนยัน',
        },
      )
      if (!resp) return

      if (resp === 'ลบข้อมูลสำเร็จ') {
        this.gDisplayToast('ลบแคมเปญนี้สำเร็จแล้ว')

        this.$router.replace({ name: 'redeem-management' })
        return
      }

      if (typeof resp === 'object' && resp.message) {
        this.gDisplayToast('พบข้อผิดพลาด', resp.message, 'danger')
      }
    },
    async copyAllCodeIsNotUse() {
      const allRedeemList = [...this.mainData.redeeming_code_datas]

      const filterIsNotUse = allRedeemList.filter(v => !v.user_id).map(v => v.code)

      if (filterIsNotUse.length <= 0) {
        this.gDisplayToast('คัดลอกไม่สำเร็จ', 'เนื่องจาก Code ทั้งหมดถูกใช้งานไปแล้ว', 'danger')
        return
      }

      const filterToString = filterIsNotUse.join('\n')
      const textTemplateCopy = `แคมเปญ : ${this.cDisplayTitle} \nจำนวนทั้งหมด ${filterIsNotUse.length} Code\nวันที่เริ่มใช้งานได้ : ${this.cMainStartDate}\nวันที่หมดอายุ : ${this.cMainEndDate} \n${filterToString}`
      // console.log('textTemplateCopy', textTemplateCopy)

      const resp = await this.$copyText(textTemplateCopy).catch(() => null)

      if (resp) {
        this.gDisplayToast('คัดลอกสำเร็จแล้ว')
      } else {
        this.gDisplayToast('คัดลอกไม่สำเร็จ', 'โปรดติดต่อผู้ดูแลระบบ', 'danger')
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
